import { Box } from '@bechtel/gds';
import styled, { css } from 'styled-components';

export interface ListSelectionHeadingStyledProps {
  moveEntireCrew: boolean;
}

export const ListSelectionHeadingStyled = styled(Box).attrs({
  pt: { sm: '450' },
  pb: { sm: '500' },
  px: { sm: '500' },
  alignItems: { sm: 'center' },
  justifyContent: { sm: 'space-between' },
})<ListSelectionHeadingStyledProps>`
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey[300]};
  cursor: pointer;
  background-color: ${({ theme }) => theme.colors.grey[100]};

  ${({ moveEntireCrew }) =>
    moveEntireCrew &&
    css`
      pointer-events: none;
    `}
`;
